import React from 'react';
import { useTranslation } from '../hooks/useTranslation';
import EditableText from './EditableText';
import EditableImage from './EditableImage';
import { useEditor } from '../contexts/EditorContext';

const HeroSection = () => {
  const { t } = useTranslation();
  const { isEditorMode } = useEditor();

  return (
    <section className="relative min-h-screen flex items-center justify-start overflow-hidden">
      {/* Background Image - More Visible */}
      {isEditorMode ? (
        <div className="absolute inset-0">
          <EditableImage
            section="hero"
            field="backgroundImage"
            src="https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80"
            alt="Hero background"
            className="w-full h-full object-cover"
          />
        </div>
      ) : (
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80')`
          }}
        />
      )}
      
      {/* Dark Navy Overlay - Gradient for readability */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#0A192F]/95 via-[#0A192F]/85 to-[#0A192F]/60"></div>

      <div className="relative z-10 container mx-auto px-6 py-20">
        <div className="max-w-3xl">
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white leading-tight mb-8">
            <EditableText
              section="hero"
              field="title"
              className="text-blue-400"
              as="span"
            >
              {t('hero.title')}
            </EditableText>
            <br />
            <EditableText
              section="hero"
              field="subtitle"
              className="text-4xl sm:text-5xl lg:text-6xl text-white"
              as="span"
            >
              {t('hero.subtitle')}
            </EditableText>
          </h1>
          
          <div className="space-y-4 text-lg sm:text-xl text-slate-200 mb-12 max-w-2xl">
            <p className="leading-relaxed">
              <EditableText section="hero" field="description1" as="span">
                {t('hero.description1')}
              </EditableText>{' '}
              <EditableText 
                section="hero" 
                field="description1Highlight" 
                className="text-blue-400 font-semibold"
                as="span"
              >
                {t('hero.description1Highlight')}
              </EditableText>
            </p>
            <p className="leading-relaxed">
              <EditableText section="hero" field="description2" as="span">
                {t('hero.description2')}
              </EditableText>
              <br />
              <EditableText 
                section="hero" 
                field="description2Highlight" 
                className="text-blue-400 font-semibold"
                as="span"
              >
                {t('hero.description2Highlight')}
              </EditableText>
            </p>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 mt-12">
            <button 
              onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 transform hover:scale-105 shadow-lg"
              data-testid="hero-cta-button"
            >
              <EditableText section="hero" field="startSourcing" as="span">
                {t('hero.startSourcing')}
              </EditableText>
            </button>
            <button 
              onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
              className="border-2 border-white/80 text-white hover:bg-white hover:text-slate-900 px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300"
              data-testid="hero-secondary-button"
            >
              <EditableText section="hero" field="learnMore" as="span">
                {t('hero.learnMore')}
              </EditableText>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;